import { RightOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { capitalize } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { MobileOpenClassSessionSummary } from '../types/OpenClassSession';
import { removeCountryFromAddress } from '../utils/address';

import OpenClassSessionStatusBadge from './OpenClassSessionStatusBadge';

type OpenClassSessionCardProps = {
  session: MobileOpenClassSessionSummary;
};

const OpenClassSessionCard: React.FC<OpenClassSessionCardProps> = ({
  session,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const start = dayjs(session.startAt);
  const end = dayjs(session.endAt);

  return (
    <div
      className="mb-4 rounded-lg flex flex-row p-2 cursor-pointer shadow-md bg-white border-solid border-grayLight border-1"
      onClick={() =>
        navigate(`/open-classes/sessions/${session.id}`, {
          state: { prevPage: location.pathname },
        })
      }>
      <div className="flex-1 px-1">
        <div className="mb-2">
          <OpenClassSessionStatusBadge status={session.status} />
        </div>
        <div className="text-blueGrayDark">
          {t('components.OpenClassSessionCard.openClass')}
          {' • '}
          {t('components.OpenClassSessionCard.session', {
            number: session.sessionNumber,
            count: session.sessionCount,
          })}
        </div>
        <div className="text-lg font-semibold mt-2 mb-1 break-words max-w-full">
          {session.courseName}
        </div>
        <div>
          {capitalize(start.format('dddd D MMMM'))}{' '}
          {t('components.CourseInstanceCard.at')} {start.format('HH:mm')}{' '}
          {t('components.CourseInstanceCard.until')}{' '}
          {/* A session running past midnight ends on a day the line has not named yet. */}
          {!start.isSame(end, 'day') &&
            `${capitalize(end.format('dddd D MMMM'))} `}
          {end.format('HH:mm')}
        </div>
        <div>{removeCountryFromAddress(session.location ?? undefined)}</div>
      </div>
      <RightOutlined className="self-center text-lg" />
    </div>
  );
};

export default OpenClassSessionCard;
